// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__25xuo","overflowing":"ReadFullNote_overflowing__1QdLG"};